export class Collection<T> implements Iterable<T> {
  private readonly values = new Map<symbol, T>();

  add(value: T): symbol {
    const key = Symbol();
    this.values.set(key, value);
    return key;
  }

  isEmpty(): boolean {
    return !this.values.size;
  }

  remove(key: symbol): boolean {
    return this.values.delete(key);
  }

  [Symbol.iterator]() {
    return this.values.values();
  }
}

// @ts-expect-error unused-export-debt
interface Difference<T> {
  left: T[];
  right: T[];
  common: [T, T][];
}

export function difference<T>(
  left: Iterable<T>,
  right: Iterable<T>,
  key: (value: T) => any = (x) => x,
): { left: T[]; right: T[]; common: [T, T][] } {
  const leftItems = new Map();
  for (const item of left) {
    leftItems.set(key(item), item);
  }
  const rightResult: T[] = [];
  const commonResult: [T, T][] = [];
  for (const item of right) {
    const k = key(item);
    if (leftItems.has(k)) {
      commonResult.push([leftItems.get(k), item]);
      leftItems.delete(k);
    } else {
      rightResult.push(item);
    }
  }
  return {
    left: Array.from(leftItems.values()),
    right: rightResult,
    common: commonResult,
  };
}
